"use client";
import { cva as t } from "class-variance-authority";
import { button as e } from "./button.js";
const i = t("", {
  variants: {
    slot: {
      root: [
        "flex items-center pl-2",
        "text-xs rounded-md h-6",
        "bg-gray-300 dark:bg-white-alpha-200",
        "min-w-0 w-fit"
      ],
      icon: ["mr-[0.5em]", "text-gray-600 dark:text-white-alpha-600"],
      title: ["overflow-hidden whitespace-nowrap text-ellipsis inline-block"],
      delete: [
        e({ variant: "iconButton", size: "md" }),
        "h-4 px-1 min-w-[unset]",
        "text-gray-600 dark:text-white-alpha-600",
        "hover:bg-transparent hover:text-gray-700",
        "dark:hover:text-white-alpha-500",
        "[&_svg]:w-4 [&_svg]:h-4"
      ]
    }
  }
});
export {
  i as attachment
};
